import styled, { css } from 'styled-components';

import { COLORS } from '@theme/colors';
import { typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

const gap = 36;

const textStyles = css`
  ${typography({})};
`;

export const Text = styled.div`
  ${textStyles};
  margin-top: ${OFFSET.S};
`;

export const LetterBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(50% - (${gap / 2}px));
  justify-content: left;
  flex-shrink: 0;

  > ${Text} {
    &:first-of-type {
      margin-top: 0;
      margin-bottom: ${OFFSET.S};
    }
  }
`;

export const ItemLink = styled.a`
  ${textStyles};
  color: ${COLORS.BLACK};
  text-decoration: none;
  display: block;
  overflow: hidden;
`;
